import { toast } from "react-toastify";
import {
  addSupplierFailure,
  addSupplierStart,
  addSupplierSuccess,
  deleteSupplierFailure,
  deleteSupplierStart,
  deleteSupplierSuccess,
  editSupplierFailure,
  editSupplierStart,
  editSupplierSuccess,
  fetchSuppliersFailure,
  fetchSupplierssStart,
  fetchSuppliersSuccess,
} from "./reducer";
import {
  addSupplierService,
  deleteSupplierService,
  editSupplierService,
  getSupplierListService,
} from "../../Services/SupplierService";

//thunk for fetch the category list
export const fetchSuppliersList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchSupplierssStart());
      const response = await getSupplierListService(params);

      if (params.isPagination === 0) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchSuppliersSuccess({
            suppliers: response.data, // full list
            // pagination: currentPagination,
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          })
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchSuppliersSuccess({
            suppliers: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          })
        );
      } else {
        dispatch(fetchSuppliersFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchSuppliersFailure(error));
    }
  };

//thunk for the addig the category

export const addSupplier = (requestParam) => async (dispatch) => {
  try {
    dispatch(addSupplierStart());

    const response = await addSupplierService(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(addSupplierSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addSupplierFailure("Failed to add Supplier"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addSupplierFailure(error));
  }
};

// //this is the thunk for delete the category
export const deleteSupplier = (supplierId) => async (dispatch) => {
  try {
    dispatch(deleteSupplierStart());

    const response = await deleteSupplierService(supplierId);

    if (response?.success) {
      toast.success(response.message);
      dispatch(deleteSupplierSuccess(supplierId));
    } else {
      toast.error("Failed to delete supplier");
      dispatch(deleteSupplierFailure("Delete failed"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(deleteSupplierFailure(error));
  }
};

// //this tunk for the edit meal category
export const editSupplier = (requestParam) => async (dispatch) => {
  try {
    dispatch(editSupplierStart());

    const response = await editSupplierService(requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(editSupplierSuccess(response));
    } else {
      dispatch(editSupplierFailure("Failed to update supplier"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(editSupplierFailure(error));
  }
};

// //this thunk is for the get by id
// export const fetchMealCategoryById = (id) => async (dispatch) => {
//   try {
//     dispatch(getCategoryByIdStart());
//     const response = await getCategoryByIdService(id);
//     if (response?.data) {
//       dispatch(getCategoryByIdSuccess(response.data));
//     } else {
//       dispatch(getCategoryByIdFailure("No category found"));
//     }
//   } catch (error) {
//     toast.error(error);
//     dispatch(getCategoryByIdFailure(error));
//   }
// };
